module.exports = __webpack_public_path__ + "img/bg-dae8e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/login/bg.png
// module id = 801
// module chunks = 0